import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import bootstrap from './bootstrap';

import './playlistControls/base.css';
import 'video.js/dist/video-js.css';
import 'videojs-contrib-ads/dist/videojs-contrib-ads.css';
import 'videojs-ima/dist/videojs.ima.css';
import 'videojs-overlay/dist/videojs-overlay.css';
import 'videojs-markers/dist/videojs.markers.css';
import 'videojs-dock/dist/videojs-dock.css';
import './css/skin.css';

bootstrap();
